import { render, staticRenderFns } from "./ResponderExterno.vue?vue&type=template&id=8ca3d984&scoped=true"
import script from "./ResponderExterno.vue?vue&type=script&lang=js"
export * from "./ResponderExterno.vue?vue&type=script&lang=js"
import style0 from "./ResponderExterno.vue?vue&type=style&index=0&id=8ca3d984&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca3d984",
  null
  
)

export default component.exports